import React, { useState, useEffect } from 'react';

import { motion, AnimatePresence, Variants } from 'framer-motion';

import { Menu, X, Volume2, VolumeX } from 'lucide-react';

import { useSound } from '../providers/SoundProvider';



const navItems = [

  { id: 'home', label: 'Home', href: '#hero' },

  { id: 'about', label: 'About', href: '#about' },

  { id: 'skills', label: 'Skills', href: '#skills' },

  { id: 'projects', label: 'Projects', href: '#projects' },

  { id: 'contact', label: 'Contact', href: '#contact' },

];



const Navigation: React.FC = () => {

  const { isSoundEnabled, toggleSound, playSound } = useSound();

  const [isOpen, setIsOpen] = useState(false);

  const [scrolled, setScrolled] = useState(false);



  useEffect(() => {

    const handleScroll = () => {

      setScrolled(window.scrollY > 20);

    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);

  }, []);



  const menuVariants: Variants = {

    hidden: { opacity: 0, y: -20 },

    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeInOut' } },

    exit: { opacity: 0, y: -20, transition: { duration: 0.3, ease: 'easeInOut' } },

  };



  return (

    <>

      <motion.nav

        initial={false}

        animate={{

          backgroundColor: scrolled ? 'rgba(10, 10, 20, 0.7)' : 'rgba(10, 10, 20, 0)',

          backdropFilter: scrolled ? 'blur(10px)' : 'blur(0px)',

          boxShadow: scrolled ? '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)' : 'none',

        }}

        transition={{ duration: 0.3, ease: 'easeOut' }}

        className="fixed top-0 left-0 right-0 z-50"

      >

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="flex justify-between items-center h-24">

            <a href="#hero" className="cursor-target text-3xl font-bold text-white hover:text-cyan-300 transition-colors duration-300 font-orbitron" onMouseEnter={() => playSound('hover')} onClick={() => playSound('click')}>

              Tornado

            </a>



            {/* Desktop Navigation */}

            <div className="hidden md:flex items-center space-x-10">

              {navItems.map((item) => (

                <a

                  key={item.id}

                  href={item.href}

                  className="cursor-target text-sm font-medium text-gray-300 hover:text-cyan-300 transition-colors duration-300 relative group"

                  onMouseEnter={() => playSound('hover')}

                  onClick={() => playSound('click')}

                >

                  <span>{item.label}</span>

                  <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-2 h-2 bg-cyan-300 rounded-full scale-0 group-hover:scale-100 transition-transform duration-300 ease-out" />

                </a>

              ))}

              <button onClick={() => { toggleSound(); playSound('click'); }} onMouseEnter={() => playSound('hover')} className="cursor-target text-gray-300 hover:text-cyan-300 transition-colors duration-300" aria-label="Toggle Sound">

                {isSoundEnabled ? <Volume2 size={22} /> : <VolumeX size={22} />}

              </button>

            </div>



            {/* Mobile Menu Button */}

            <button

              className="md:hidden text-gray-300 hover:text-cyan-300"

              onClick={() => setIsOpen(!isOpen)}

              aria-label="Toggle menu"

            >

              {isOpen ? <X size={32} /> : <Menu size={32} />}

            </button>

          </div>

        </div>

      </motion.nav>



      {/* Mobile Navigation - Full-screen overlay */}

      <AnimatePresence>

        {isOpen && (

          <motion.div

            variants={menuVariants}

            initial="hidden"

            animate="visible"

            exit="exit"

            className="fixed inset-0 z-40 bg-gray-900/90 backdrop-blur-xl md:hidden flex items-center justify-center"

          >

            <div className="flex flex-col items-center justify-center h-full space-y-10">

              {navItems.map((item) => (

                <a

                  key={item.id}

                  href={item.href}

                  className="cursor-target text-3xl font-semibold text-gray-200 hover:text-cyan-300 transition-colors duration-300"

                  onMouseEnter={() => playSound('hover')}

                  onClick={() => { playSound('click'); setIsOpen(false); }}

                >

                  {item.label}

                </a>

              ))}

              <button 

                onClick={() => { toggleSound(); playSound('click'); }} 

                onMouseEnter={() => playSound('hover')} 

                className="cursor-target text-gray-200 hover:text-cyan-300 transition-colors duration-300 mt-8"

              >

                {isSoundEnabled ? <Volume2 size={28} /> : <VolumeX size={28} />}

              </button>

            </div>

          </motion.div>

        )}

      </AnimatePresence>

    </>

  );

};



export default Navigation;